/**
 * @generated SignedSource<<70475c9d29d1800f98ebde7d315b6dbb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type DevOpsBuildState = "CANCELLED" | "FAILED" | "IN_PROGRESS" | "PENDING" | "SUCCESSFUL" | "UNKNOWN" | "%future added value";
export type JiraPullRequestState = "DECLINED" | "DRAFT" | "MERGED" | "OPEN" | "%future added value";
export type JiraReviewState = "APPROVAL" | "CLOSED" | "DEAD" | "DRAFT" | "REJECTED" | "REVIEW" | "SUMMARIZE" | "UNKNOWN" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_issueEdges$data = ReadonlyArray<{
  readonly node: {
    readonly devOpsSummarisedEntities?: {
      readonly summarisedBuilds: {
        readonly buildStates: ReadonlyArray<{
          readonly count: number | null | undefined;
          readonly state: DevOpsBuildState | null | undefined;
        } | null | undefined> | null | undefined;
        readonly count: number | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly devSummaryCache?: {
      readonly devSummary: {
        readonly build: {
          readonly overall: {
            readonly count: number;
            readonly failedBuildCount: number;
          };
        };
        readonly commit: {
          readonly overall: {
            readonly count: number;
          };
        };
        readonly pullrequest: {
          readonly overall: {
            readonly count: number;
            readonly state: JiraPullRequestState;
          };
        };
        readonly review: {
          readonly overall: {
            readonly count: number;
            readonly state: JiraReviewState | null | undefined;
          };
        };
      };
    };
    readonly fieldsById: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly fieldId: string;
          readonly status?: {
            readonly statusCategory: {
              readonly statusCategoryId: string;
            } | null | undefined;
          };
        } | null | undefined;
      } | null | undefined>;
    };
  } | null | undefined;
  readonly " $fragmentType": "ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_issueEdges";
}>;
export type ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_issueEdges$key = ReadonlyArray<{
  readonly " $data"?: ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_issueEdges$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_issueEdges">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "count"
},
v1 = {
  "kind": "ScalarField",
  "name": "state"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isDevopsFeatureDisabledInFedRamp"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ui_softwareReleasesVersionIssueWarningController_IssuesWarningCountProvider_issueEdges",
  "selections": [
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "args": [
              {
                "kind": "Literal",
                "name": "ids",
                "value": [
                  "priority",
                  "summary",
                  "assignee",
                  "status",
                  "issuetype"
                ]
              }
            ],
            "concreteType": "JiraIssueFieldConnection",
            "kind": "LinkedField",
            "name": "fieldsById",
            "plural": false,
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "concreteType": "JiraIssueFieldEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": {
                            "kind": "ScalarField",
                            "name": "fieldId"
                          },
                          "action": "THROW",
                          "path": "node.fieldsById.edges.node.fieldId"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "concreteType": "JiraStatus",
                              "kind": "LinkedField",
                              "name": "status",
                              "plural": false,
                              "selections": [
                                {
                                  "concreteType": "JiraStatusCategory",
                                  "kind": "LinkedField",
                                  "name": "statusCategory",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "ScalarField",
                                      "name": "statusCategoryId"
                                    }
                                  ]
                                }
                              ]
                            }
                          ],
                          "type": "JiraStatusField"
                        }
                      ]
                    }
                  ]
                },
                "action": "THROW",
                "path": "node.fieldsById.edges"
              }
            ],
            "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
          },
          "action": "THROW",
          "path": "node.fieldsById"
        },
        {
          "condition": "isDevopsFeatureDisabledInFedRamp",
          "kind": "Condition",
          "passingValue": false,
          "selections": [
            {
              "concreteType": "DevOpsSummarisedEntities",
              "kind": "LinkedField",
              "name": "devOpsSummarisedEntities",
              "plural": false,
              "selections": [
                {
                  "concreteType": "DevOpsSummarisedBuilds",
                  "kind": "LinkedField",
                  "name": "summarisedBuilds",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "concreteType": "DevOpsSummarisedBuildState",
                      "kind": "LinkedField",
                      "name": "buildStates",
                      "plural": true,
                      "selections": [
                        (v1/*: any*/),
                        (v0/*: any*/)
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "kind": "RequiredField",
              "field": {
                "concreteType": "JiraIssueDevSummaryResult",
                "kind": "LinkedField",
                "name": "devSummaryCache",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "JiraIssueDevSummary",
                      "kind": "LinkedField",
                      "name": "devSummary",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "RequiredField",
                          "field": {
                            "concreteType": "JiraIssuePullRequestDevSummaryContainer",
                            "kind": "LinkedField",
                            "name": "pullrequest",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": {
                                  "concreteType": "JiraIssuePullRequestDevSummary",
                                  "kind": "LinkedField",
                                  "name": "overall",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "RequiredField",
                                      "field": (v1/*: any*/),
                                      "action": "NONE",
                                      "path": "node.devSummaryCache.devSummary.pullrequest.overall.state"
                                    },
                                    {
                                      "kind": "RequiredField",
                                      "field": (v0/*: any*/),
                                      "action": "NONE",
                                      "path": "node.devSummaryCache.devSummary.pullrequest.overall.count"
                                    }
                                  ]
                                },
                                "action": "NONE",
                                "path": "node.devSummaryCache.devSummary.pullrequest.overall"
                              }
                            ]
                          },
                          "action": "NONE",
                          "path": "node.devSummaryCache.devSummary.pullrequest"
                        },
                        {
                          "kind": "RequiredField",
                          "field": {
                            "concreteType": "JiraIssueReviewDevSummaryContainer",
                            "kind": "LinkedField",
                            "name": "review",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": {
                                  "concreteType": "JiraIssueReviewDevSummary",
                                  "kind": "LinkedField",
                                  "name": "overall",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "RequiredField",
                                      "field": (v0/*: any*/),
                                      "action": "NONE",
                                      "path": "node.devSummaryCache.devSummary.review.overall.count"
                                    },
                                    (v1/*: any*/)
                                  ]
                                },
                                "action": "NONE",
                                "path": "node.devSummaryCache.devSummary.review.overall"
                              }
                            ]
                          },
                          "action": "NONE",
                          "path": "node.devSummaryCache.devSummary.review"
                        },
                        {
                          "kind": "RequiredField",
                          "field": {
                            "concreteType": "JiraIssueCommitDevSummaryContainer",
                            "kind": "LinkedField",
                            "name": "commit",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": {
                                  "concreteType": "JiraIssueCommitDevSummary",
                                  "kind": "LinkedField",
                                  "name": "overall",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "RequiredField",
                                      "field": (v0/*: any*/),
                                      "action": "NONE",
                                      "path": "node.devSummaryCache.devSummary.commit.overall.count"
                                    }
                                  ]
                                },
                                "action": "NONE",
                                "path": "node.devSummaryCache.devSummary.commit.overall"
                              }
                            ]
                          },
                          "action": "NONE",
                          "path": "node.devSummaryCache.devSummary.commit"
                        },
                        {
                          "kind": "RequiredField",
                          "field": {
                            "concreteType": "JiraIssueBuildDevSummaryContainer",
                            "kind": "LinkedField",
                            "name": "build",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": {
                                  "concreteType": "JiraIssueBuildDevSummary",
                                  "kind": "LinkedField",
                                  "name": "overall",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "RequiredField",
                                      "field": (v0/*: any*/),
                                      "action": "NONE",
                                      "path": "node.devSummaryCache.devSummary.build.overall.count"
                                    },
                                    {
                                      "kind": "RequiredField",
                                      "field": {
                                        "kind": "ScalarField",
                                        "name": "failedBuildCount"
                                      },
                                      "action": "NONE",
                                      "path": "node.devSummaryCache.devSummary.build.overall.failedBuildCount"
                                    }
                                  ]
                                },
                                "action": "NONE",
                                "path": "node.devSummaryCache.devSummary.build.overall"
                              }
                            ]
                          },
                          "action": "NONE",
                          "path": "node.devSummaryCache.devSummary.build"
                        }
                      ]
                    },
                    "action": "NONE",
                    "path": "node.devSummaryCache.devSummary"
                  }
                ]
              },
              "action": "NONE",
              "path": "node.devSummaryCache"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraIssueEdge"
};
})();

(node as any).hash = "2af391280f3df5e713e3630effb3b264";

export default node;
